export default {
  defaultTitle: 'Необычные экскурсии и туры по всему миру',
} as const;
